import * as Yup from 'yup'

export const cleaningScheduleSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoEdificacionId: Yup.string().required('Tipo de Edificación es requerido'),
  Nomenclatura: Yup.string().required('Programación de Servicio es requerido'),
  FechaInicio: Yup.string().when('EsPeriodico', {
    is: true,
    then: Yup.string().required('La fecha es obligatorio'),
    otherwise: Yup.string(),
  }),
  FechaFin: Yup.string().when('EsPeriodico', {
    is: true,
    then: Yup.string().required('La fecha es obligatorio'),
    otherwise: Yup.string(),
  }),
  HoraInicio: Yup.string().when('EsPeriodico', {
    is: true,
    then: Yup.string().required('La hora es obligatorio'),
    otherwise: Yup.string(),
  }),
  CantidadRepeticion: Yup.number().when('EsPeriodico', {
    is: true,
    then: Yup.number()
      .typeError('Repetir cada es obligatorio')
      .required('Repetir cada es obligatorio')
      .min(1, 'El valor mínimo es 1'),
    otherwise: Yup.number(),
  }),
  TipoRepeticion: Yup.string().when('EsPeriodico', {
    is: true,
    then: Yup.string().required('Tipo de repetición es obligatorio'),
    otherwise: Yup.string(),
  }),
  // days: Yup.array().when('EsPeriodico', {
  //   is: true,
  //   then: Yup.array()
  //     .of(Yup.boolean())
  //     .test('at-least-one-true', 'Seleccione al menos un día', (value) => {
  //       return value ? value.some((v) => v === true) : false
  //     }),
  //   otherwise: Yup.array().of(Yup.boolean()),
  // }),
})